const KaseyaUsersImport = () => import('@/views/account/integrations/kaseya/import/kaseya-users-import-view.vue');
const KaseyaCompaniesImport = () => import('@/views/account/integrations/kaseya/import/kaseya-companies-import-view.vue');
const KaseyaContactsImport = () => import('@/views/account/integrations/kaseya/import/kaseya-contacts-import-view');
const KaseyaActivitiesImport = () => import('@/views/account/integrations/kaseya/import/kaseya-activities-import-view');
const KaseyaOpportunitiesImport = () => import('@/views/account/integrations/kaseya/import/kaseya-opportunities-status-import-view');

import store from '@/stores/index';

export default [
    {
        path: '/Integrations/Kaseya/Manage/Users/Import',
        name: 'KaseyaUsersImport',
        component: KaseyaUsersImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Kaseya/Manage/Users/Import',
        name: 'ClientKaseyaUsersImport',
        component: KaseyaUsersImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/Kaseya/Manage/Companies/Import',
        name: 'KaseyaCompaniesImport',
        component: KaseyaCompaniesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Kaseya/Manage/Companies/Import',
        name: 'ClientKaseyaCompaniesImport',
        component: KaseyaCompaniesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/Kaseya/Manage/Contacts/Import',
        name: 'KaseyaContactsImport',
        component: KaseyaContactsImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Kaseya/Manage/Contacts/Import',
        name: 'ClientKaseyaContactsImport',
        component: KaseyaContactsImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/Kaseya/Manage/Activities/Import',
        name: 'KaseyaActivitiesImport',
        component: KaseyaActivitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Kaseya/Manage/Activities/Import',
        name: 'ClientKaseyaActivitiesImport',
        component: KaseyaActivitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/Kaseya/Manage/Opportunities/Import',
        name: 'KaseyaOpportunitiesImport',
        component: KaseyaOpportunitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Kaseya/Manage/OpportunitiesStatus/Import',
        name: 'ClientKaseyaOpportunitiesImport',
        component: KaseyaOpportunitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    }
]